import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AuthHeader from '@/pages/auth/components/common/AuthHeader';

const AuthLayout = ({ children, showHeader = true }) => {
  return (
    <Fragment>
      <div className="auth">
        <div className="auth__sidebar">
          <div className="form-container h-100 margin-top-2">
            {showHeader && <AuthHeader />}

            {/* Logo Section */}
            <div className="form-container__logo">
              <div className="form-container__logo--sample" />
            </div>

            {/* Main Content */}
            <div className="form-container__body margin-top-2 flex items-center justify-center min-h-0 flex-1">
              {children}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  showHeader: PropTypes.bool,
};

export default AuthLayout;
